{
  "automations": {
    "navigation_title": "Automatizaciones",
    "title": "Automatizaciones",
    "hvac": {
      "navigation_title": "HVAC",
      "title": "HVAC"
    },
    "rule_1466": {
      "navigation_title": "Regla 1466",
      "title": "Regla 1466"
    }
  }
}
